import { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Link as RouterDomLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { AppNavbar } from './Components/Navbar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { MsalAuthenticationResult, MsalAuthenticationTemplate, useAccount, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from './msal';
import { TestAutomation } from './Pages/TestAutomation';
import { ContactUs } from './Pages/ContactUs';

const theme = createTheme({
  palette: {mode: 'light'},
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1rem',
        },
      },
    },
  },
});

function App() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState<string>();

  function RequestAccessToken() {
    const request = {
      ...loginRequest,
      account: accounts[0]
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    instance.acquireTokenSilent(request).then((response) => {
      setAccessToken(response.accessToken);
    }).catch((e) => {
      instance.acquireTokenRedirect(request);
    });
  }

  function signOutClickHandler() {
    const logoutRequest = {
      account: account,
      postLogoutRedirectUri: "https://www.gritsoftwaresystems.com/"
    }
    instance.logoutRedirect(logoutRequest);
  }

  useEffect(() => {
    // make API call
  }, [])

  useEffect(() => {
    console.log(accessToken);
  }, [accessToken]);

  const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => {
    return <p>An Error Occurred: {error}</p>;
  }

  function LoadingComponent() {
    return <p>Authentication in progress...</p>;
  }
  const authRequest = {
    scopes: ["openid", "profile"]
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={LoadingComponent}
    >
      <ThemeProvider theme={theme}>
        {/*<button onClick={RequestAccessToken}>Click Me</button>*/}
        <Box>
          <BrowserRouter>
            <AppNavbar signOutClickHandler={signOutClickHandler} />
            <Routes>
              <Route path="/" element={<Navigate replace to="/test-automation/" />}
              />
              <Route path="/contact-us" element={
                <ContactUs />}
              />
              <Route path="/test-automation/*" element={
                <TestAutomation />}
              />
            </Routes>
            <Paper sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, position: 'fixed', bottom: 0, width: '100%'}}>
              <footer style={{ width: '100%'}} className='d-flex justify-content-between px-3'>
                <div>&copy;{new Date().getFullYear()} Grit Software Systems</div>
                <div>For assistance please <Link component={RouterDomLink} to='/contact-us'>contact us here</Link></div>
              </footer>
            </Paper>
          </BrowserRouter>
        </Box>
      </ThemeProvider>
    </MsalAuthenticationTemplate>
  );
}

export default App;